import React from 'react';

import OhsAngularIframe from 'global-components/angular-iframe/OhsAngularIframe';

export default function OhsInspectionLinkAccessHome() {
  return <OhsAngularIframe />;
}
